import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CustomRespondConfirmation } from '../objects/DialogObject'
import { CustomPopupComponent } from '../custom-popup/custom-popup.component';


@Injectable({
  providedIn: 'root'
})
export class CustomPopupService {

  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
    private customRespondConfirmation: CustomRespondConfirmation
  ) { }

  confirm(title: string, content: any, inputText: string, options: string[], selectedItem: string): Observable<CustomRespondConfirmation> {
    const initialState = {
      title: title,
      content:content,
      options:options,
      inputText: inputText,
      selectedItem: selectedItem
    };

    if (this.bsModalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
    }

    this.bsModalRef = this.bsModalService.show(CustomPopupComponent, { class: "modal-dialog-centered modal-custom", ignoreBackdropClick: true, keyboard:false, initialState });

    return new Observable<CustomRespondConfirmation>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string) => {
        document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
        if (this.bsModalService.getModalsCount() > 0){
          // if (this.bsModalRef.content.answer == 'OK'){
          //   for (let i = 1; i <= this.bsModalService.getModalsCount(); i++) {
          //     this.bsModalService.hide(i);
          //   }
          //   document.body.classList.remove('modal-open');
          // }
          // else {
            document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.add('show');
          // }
        }
        this.customRespondConfirmation.respondObject = this.bsModalRef.content.respondObject;
        this.customRespondConfirmation.answer = this.bsModalRef.content.answer;
        observer.next(this.customRespondConfirmation);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }

}


